
// Merge into a locale object
const trLocale ={
    "lang": {
      "locale": "tr_TR",
      "today": "Bugün",
      "now": "Bugün",
      "ok": "OK",
      "clear": "Clear",
      "yearFormat": "YYYY",
      "dateFormat": "M/D/YYYY",
      "dayFormat": "D",
      "dateTimeFormat": "M/D/YYYY HH:mm:ss",
      "shortWeekDays": ['Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct', 'Pz'],
      "shortMonths": ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']
    },
    "timePickerLocale": {
      "placeholder": "Tarih Seç"
    },
    "dateFormat": "YYYY-MM-DD",
    "dateTimeFormat": "YYYY-MM-DD HH:mm:ss",
    "weekFormat": "YYYY-wo",
    "monthFormat": "YYYY-MM"
  };

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

export default trLocale;